export default __webpack_public_path__ + "sounds/boi mario.mp3";